import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_ESA: TStep[] = [
  {
    pageId: PageId.DOG_AGE_ESA,
  },
  {
    pageId: PageId.MOTIVATION_ESA,
  },
  {
    pageId: PageId.ESA_LETTER,
  },
  {
    pageId: PageId.ACCOMPANY_ESA,
  },
  {
    pageId: PageId.HAPPINESS_ESA,
  },
  {
    pageId: PageId.SADNESS_ESA,
  },
  {
    pageId: PageId.TRY_ESA,
  },
  {
    pageId: PageId.FULL_SUPPORT_ESA,
  },
  {
    pageId: PageId.EXPERT_ESA,
  },
  {
    pageId: PageId.PERSONALIZED_ESA,
  },
  {
    pageId: PageId.MENTAL_HEALTH_ESA,
  },
  {
    pageId: PageId.SADNESS_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.ANGER_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.WORRY_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.AFRAID_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.SLEEP_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.NERVOUS_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.MEMORY_LAST_WEEKS_ESA,
  },
  {
    pageId: PageId.FOCUS_ESA,
  },
  {
    pageId: PageId.EMOTIONAL_SCORE_ESA,
  },
  {
    pageId: PageId.DOG_NOTICE_UPSET_ESA,
  },
  {
    pageId: PageId.DOG_NEXT_TO_YOU_ESA,
  },
  {
    pageId: PageId.DOG_SUPPORT_CUES_ESA,
  },
  {
    pageId: PageId.STATS_ESA,
  },
  {
    pageId: PageId.DOG_BREED_ESA,
  },
  {
    pageId: PageId.DOG_SIZE_ESA,
  },
  {
    pageId: PageId.URGE_ESA,
  },
  {
    pageId: PageId.PREPARE_FLOW_ESA,
  },
  {
    pageId: PageId.PLAN_ESA,
  },
  {
    pageId: PageId.EMAIL_ESA,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_ESA,
  },
  {
    pageId: PageId.CANCEL_OFFER_ESA,
  },
  {
    pageId: PageId.CHAT_UPSELL_ESA,
  },
  {
    pageId: PageId.UPSELL_ESA,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_ESA,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_ESA.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_ESA.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
